// Home.jsx
//
// 2026-05-26 cleanup: Reporting embed removed. Home is now a single-panel
// layout — just Relationships. Reporting is hidden from the main nav and
// no longer shown inline here either. Reporting.jsx and its route are
// preserved (still rendered when `view === 'reporting'`), the import and
// inline render were the only things stripped here.
//
// 2026-05-08 cleanup (historical): stripped tasks/requests/done/monitoring
// + their ModeFlipper, panels and modals. The greetings + HomeModals +
// ReportsPanel internals were retired alongside the tasks tables (mig 133).

import RelationshipsPanel from '../relationships/RelationshipsPanel';

export default function Home({ session }) {
  return (
    <div
      style={{
        padding: 24,
        minHeight: 'calc(100vh - 80px)',
        background: '#fafafa',
      }}
    >
      <RelationshipsPanel session={session} />
    </div>
  );
}
